import React from 'react';
import socialToken from '../actions/socialToken';
import Loading from '../components/Loading';
import { INVALID_IDENTITY_PROVIDER_SIGNUP } from '../constants/errorCodes';
import { INVALID_IDP_USER } from '../constants/routes';
import { OAUTH_QS_KEY } from '../constants/storage';
import pendo from '../services/pendo';
import queryString from '../services/queryString';
import routing from '../services/routing';
import storage from '../services/storage';

export const context = 'idpToken';
export class IdpTokenRoute extends React.PureComponent {
    state = {
        error: '',
    };

    async componentDidMount() {
        const queryParams = queryString.parse(routing.location.search);
        // Check for valid errors returned by cognito
        if (queryParams.error_description && queryParams.error_description.includes(INVALID_IDENTITY_PROVIDER_SIGNUP)) {
            routing.push(INVALID_IDP_USER, storage.loadState(OAUTH_QS_KEY) ?? {});
            return;
        }
        try {
            await socialToken(() => pendo.trackEvent(pendo.buildAnonymousVisitor(), 'Google Token Redeemed'));
        } catch (error) {
            this.setState({
                error: error.message,
            });
        }
    }

    render() {
        const { error } = this.state;

        if (error) {
            throw error;
        }
        return <Loading />;
    }
}

export default IdpTokenRoute;
